<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Montaże</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Montaże</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight logs">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span :class="chevronFiltersClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isFiltersOpen">
            <div class="row">
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Zamknięty</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.closed"
                      mode="tags"
                      placeholder="Zamknięty"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterOptions"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Zmontowany</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.mounted"
                      mode="tags"
                      placeholder="Zmontowany"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterOptions"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Naświetlony</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.radiated"
                      mode="tags"
                      placeholder="Zmontowany"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterOptions"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Wydrukowany</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.printed"
                      mode="tags"
                      placeholder="Wydrukowany"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterOptions"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Wybierz daty</label>
                  <div class="col-sm-8">
                    <VueDatePicker
                      class="stats-daterangepicker"
                      v-model="filterRangeDate"
                      multi-calendars
                      :format="format"
                      range
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Status RW</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="filters.rw_status"
                      mode="tags"
                      placeholder="Status RW"
                      track-by="name"
                      label="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="filterRWOptions"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
              <div
                class="col-md-3 nopadding"
                v-if="canDisplaySites && filterSites.length"
              >
                <div class="form-group">
                  <label class="control-label col-sm-2">Domena</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="sitePk"
                      mode="single"
                      placeholder="Domena"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="filterSites"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 mtgs">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Montaże</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddMontage" to="/montages/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <!-- Kafelki podsumowania -->
            <div
              class="row summary-tiles"
              v-if="montagesListSummaryClosed && montagesListSummaryClosed.data"
            >
              <div class="col-md-4">
                <div class="summary-tile">
                  <div class="summary-tile-label">
                    Ilość płyt do naświetlenia
                  </div>
                  <div class="summary-tile-value">
                    {{
                      formatInt(montagesListSummaryClosed.data.plate_quantity)
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="summary-tile">
                  <div class="summary-tile-label">
                    Ilość arkuszy do wydrukowania
                  </div>
                  <div class="summary-tile-value">
                    {{
                      formatInt(montagesListSummaryClosed.data.quantity_gross)
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="summary-tile has-popover">
                  <div class="summary-tile-label">
                    Ilość podłoży do produkcji
                  </div>
                  <div class="summary-tile-value">
                    {{ formatInt(montagesListSummaryClosed.data.paper_count) }}
                  </div>
                  <div
                    class="summary-popover"
                    v-if="
                      montagesListSummaryClosed.data.paper_format_list &&
                      montagesListSummaryClosed.data.paper_format_list.length
                    "
                  >
                    <div class="summary-popover-title">Lista podłoży</div>
                    <div class="summary-popover-header">
                      <span class="paper-name">Papier</span>
                      <span class="paper-format">Format</span>
                      <span class="paper-total">Ilość</span>
                    </div>
                    <ul class="summary-popover-list">
                      <li
                        v-for="paper in paperList"
                        :key="`${paper.paper_option_pk}-${paper.sheet_format_pk}`"
                      >
                        <span class="paper-name">
                          {{ paper.paper_option_label }}
                        </span>
                        <span class="paper-format">
                          {{ paper.sheet_format_size }}
                        </span>
                        <span class="paper-total">
                          {{ formatInt(paper.total) }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Zakładki -->
            <div class="row">
              <div class="col-sm-12">
                <div class="custom-tabs">
                  <div class="tab-buttons">
                    <button
                      class="tab-button"
                      :class="{ active: activeTab === 'montages' }"
                      @click="activeTab = 'montages'"
                    >
                      <i class="fa fa-list"></i>
                      <span>Lista montaży</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Zawartość zakładek -->
            <div v-if="activeTab === 'montages'" class="tab-content">
              <div class="row">
                <div class="col-sm-12 m-b-xs" v-if="items">
                  <button @click="resetFilters" class="btn btn-primary btn-xs">
                    <i class="fa fa-refresh"></i>
                  </button>
                  <div class="pagination" v-if="itemsAll">
                    <span class="items-all">
                      Ilość rekordów: <b>{{ itemsAll }}</b>
                    </span>
                    <span>
                      Ilość na stronę:
                      <select v-model="serverOptions.rowsPerPage">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </span>
                    <span>
                      <input
                        type="number"
                        v-model.number="serverOptions.page"
                        @change="
                          serverOptions.page = clampPage(serverOptions.page)
                        "
                      />
                      -
                      {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                    </span>
                    <button
                      @click="selectPage(1)"
                      class="btn btn-primary ml-25"
                    >
                      Pierwsza
                    </button>
                    <button
                      @click="selectPage(serverOptions.page - 1)"
                      :disabled="serverOptions.page === 1"
                      class="prev nl"
                    ></button>
                    <button
                      @click="selectPage(serverOptions.page + 1)"
                      :disabled="
                        serverOptions.page ===
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      "
                      class="next"
                    ></button>
                    <button
                      @click="
                        selectPage(
                          Math.ceil(itemsAll / serverOptions.rowsPerPage)
                        )
                      "
                      class="btn btn-primary"
                    >
                      Ostatnia
                    </button>
                  </div>
                </div>
              </div>

              <!-- Sekcja Podsumowanie nad tabelą -->
              <div v-if="activeTab === 'montages'" class="ibox-title">
                <h5>Podsumowanie</h5>
              </div>
              <div v-if="activeTab === 'montages'" class="ibox-content">
                <!-- Summary table -->
                <div
                  v-if="montagesListSummary && montagesListSummary.data"
                  class="table-summary"
                >
                  <!-- Column labels row -->
                  <div class="row summary-labels">
                    <div class="col-md-2">
                      <strong>Podsumowanie:</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>Nakład netto</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>Produkty netto</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>Koszt montażu</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>Koszt naddatku</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>Różnica</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>Procent</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>Dodatkowa netto</strong>
                    </div>
                  </div>
                  <!-- Values row -->
                  <div class="row summary-values">
                    <div class="col-md-2">
                      <span class="text-muted">Wartości:</span>
                    </div>
                    <div class="col-md-1">
                      <strong>{{
                        formatCurrency(montagesListSummary.data.quantity_net)
                      }}</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>
                        {{
                          formatCurrency(montagesListSummary.data.products_net)
                        }}
                      </strong>
                    </div>
                    <div class="col-md-1">
                      <strong>
                        {{
                          formatCurrency(
                            Number(montagesListSummary.data.montage_cost || 0) +
                              Number(montagesListSummary.data.extra_net || 0)
                          )
                        }}
                      </strong>
                    </div>
                    <div class="col-md-1">
                      <strong>
                        {{
                          formatCurrency(montagesListSummary.data.surplus_cost)
                        }}
                      </strong>
                    </div>
                    <div class="col-md-1">
                      <strong>
                        {{
                          formatCurrency(montagesListSummary.data.difference)
                        }}
                      </strong>
                    </div>
                    <div class="col-md-1">
                      <strong>{{ montagesListSummary.data.percent }}%</strong>
                    </div>
                    <div class="col-md-1">
                      <strong>
                        {{ formatCurrency(montagesListSummary.data.extra_net) }}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <EasyDataTable
                    ref="montagesTableRef"
                    v-model:server-options="serverOptions"
                    :server-items-length="itemsAll"
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    :body-row-class-name="bodyRowClassNameFunction"
                    alternating
                    multi-sort
                    border-cell
                    show-index
                    class="table-search"
                  >
                    <template #header="header">
                      <span v-if="header.text" @click="updateSort">
                        {{ header.text }}
                      </span>
                      <input
                        class="table-search"
                        type="text"
                        v-if="header.search"
                        v-model="searchValue[header.value]"
                        @keyup="search"
                        @click="isSearch = true"
                      />
                    </template>
                    <template #item-quantity_brutto="item">
                      {{ (item.quantity_net + item.surplus_cost).toFixed(2) }}
                    </template>
                    <template #item-surplus_cost="item">
                      {{ item.surplus_cost.toFixed(2) }}
                    </template>
                    <template #item-montage_cost="item">
                      {{ getMontageCostWithExtra(item).toFixed(2) }}
                    </template>
                    <template #item-percent="item">
                      {{ item.percent.toFixed(2) }}
                    </template>
                    <template #item-actions="item">
                      <template v-if="!item.isSummary">
                        <router-link
                          v-if="canChangeMontage"
                          :to="'/montages/edit/' + item.pk"
                        >
                          <button class="btn btn-warning btn-xs">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </button>
                        </router-link>
                        <!-- Same order as the old panel: edit, delete, row
                             actions, history. -->
                        <button
                          v-if="canDeleteMontage"
                          @click="
                            showModal = item.pk;
                            deleteName = item.name;
                          "
                          class="btn btn-danger btn-xs"
                          title="Usuń"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <button
                          v-if="canDuplicateMontage"
                          :disabled="isDuplicating"
                          @click="askDuplicateMontage(item.pk)"
                          class="btn btn-primary btn-xs"
                          title="Duplikuj"
                        >
                          <i class="fa fa-copy"></i>
                        </button>
                        <button
                          @click="getMontageCard(item.pk)"
                          title="Pobierz kartę"
                          class="btn btn-primary btn-xs"
                        >
                          <i class="fa fa-file"></i>
                        </button>
                        <button
                          @click="realization(item.pk)"
                          class="btn btn-primary btn-xs"
                          title="Do realizacji"
                        >
                          <i class="fa fa-list-alt"></i>
                        </button>
                        <HistoryPopover
                          :logs="item.production_logs || []"
                          position="bottom-left"
                        />
                      </template>
                    </template>
                  </EasyDataTable>
                </div>
              </div>

              <!-- Paginacja pod tabelą -->
              <div class="row">
                <div class="col-sm-12 m-b-xs" v-if="items">
                  <div class="pagination" v-if="itemsAll">
                    <span class="items-all">
                      Ilość rekordów: <b>{{ itemsAll }}</b>
                    </span>
                    <span>
                      Ilość na stronę:
                      <select v-model="serverOptions.rowsPerPage">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </span>
                    <span>
                      <input
                        type="number"
                        v-model.number="serverOptions.page"
                        @change="
                          serverOptions.page = clampPage(serverOptions.page)
                        "
                      />
                      -
                      {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                    </span>
                    <button
                      @click="selectPage(1)"
                      class="btn btn-primary ml-25"
                    >
                      Pierwsza
                    </button>
                    <button
                      @click="serverOptions.page = serverOptions.page - 1"
                      :disabled="serverOptions.page === 1"
                      class="prev nl"
                    ></button>
                    <button
                      @click="serverOptions.page = serverOptions.page + 1"
                      :disabled="
                        serverOptions.page ===
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      "
                      class="next"
                    ></button>
                    <button
                      @click="
                        selectPage(
                          Math.ceil(itemsAll / serverOptions.rowsPerPage)
                        )
                      "
                      class="btn btn-primary"
                    >
                      Ostatnia
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="mActions" class="modal-dialog realization">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">
            Realizacja montażu nr:
            {{ realizationMontage.pk }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="panel-body">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="ibox">
                      <button
                        v-if="canSetStatus('closed')"
                        @click="
                          endProcess(
                            realizationMontage?.pk,
                            !realizationMontage?.closed,
                            'closed'
                          )
                        "
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage?.closed,
                          'btn-default': !realizationMontage?.closed,
                        }"
                      >
                        <i
                          v-if="realizationMontage?.closed"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Zamknięty</span>
                      </button>

                      <button
                        v-if="canSetStatus('mounted')"
                        @click="
                          endProcess(
                            realizationMontage?.pk,
                            !realizationMontage?.mounted,
                            'mounted'
                          )
                        "
                        :disabled="realizationMontage?.radiated"
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage?.mounted,
                          'btn-default': !realizationMontage?.mounted,
                        }"
                      >
                        <i
                          v-if="realizationMontage?.mounted"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Zmontowany</span>
                      </button>

                      <button
                        v-if="canSetStatus('radiated')"
                        @click="
                          endProcess(
                            realizationMontage?.pk,
                            !realizationMontage?.radiated,
                            'radiated'
                          )
                        "
                        :disabled="realizationMontage?.printed"
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage?.radiated,
                          'btn-default': !realizationMontage?.radiated,
                        }"
                      >
                        <i
                          v-if="realizationMontage?.radiated"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Naświetlony</span>
                      </button>

                      <button
                        v-if="canSetStatus('printed')"
                        @click="
                          endProcess(
                            realizationMontage?.pk,
                            !realizationMontage?.printed,
                            'printed'
                          )
                        "
                        class="btn"
                        :class="{
                          'btn-primary': realizationMontage?.printed,
                          'btn-default': !realizationMontage?.printed,
                        }"
                      >
                        <i
                          v-if="realizationMontage?.printed"
                          class="fa fa-check"
                        ></i>
                        <i v-else class="fa fa-times"></i>
                        <span> Wydrukowany</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row-eq-height row">
                  <div v-if="showProcessBox('closed')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{
                        'unactive-cube': realizationMontage?.closed,
                      }"
                    >
                      <b>
                        <h2 v-if="realizationMontage?.closed">Zamknięty</h2>
                        <h2 v-else>Zamykanie</h2>
                        <small v-if="realizationMontage?.closed">
                          Poprzedni etap
                        </small>
                        <small v-else-if="!realizationMontage?.closed">
                          Aktualny etap
                        </small>
                      </b>
                    </div>
                  </div>
                  <div v-if="showProcessBox('mounted')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{
                        'unactive-cube':
                          (currentProcess() &&
                            currentProcess() !== 'mounted') ||
                          realizationMontage?.mounted,
                      }"
                    >
                      <b>
                        <h2 v-if="realizationMontage?.mounted">Zmontowany</h2>
                        <h2 v-else>Montaż</h2>
                        <small v-if="realizationMontage?.mounted">
                          Poprzedni etap
                        </small>
                        <small
                          v-else-if="
                            realizationMontage?.closed &&
                            !realizationMontage?.mounted
                          "
                        >
                          Aktualny etap
                        </small>
                        <small v-else>Następny etap</small>
                      </b>
                    </div>
                  </div>
                  <div v-if="showProcessBox('radiated')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{
                        'unactive-cube':
                          (currentProcess() &&
                            currentProcess() !== 'radiated') ||
                          realizationMontage?.radiated,
                      }"
                    >
                      <b>
                        <h2 v-if="realizationMontage?.radiated">Naświetlony</h2>
                        <h2 v-else>Naświetlanie</h2>
                        <small v-if="realizationMontage?.radiated">
                          Poprzedni etap
                        </small>
                        <small v-else-if="realizationMontage?.mounted">
                          Aktualny etap
                        </small>
                        <small v-else>Następny etap</small>
                      </b>
                    </div>
                  </div>

                  <div v-if="showProcessBox('printed')" class="col-md-3">
                    <div
                      class="nomargin height-100-pc widget lazur-bg p-xl"
                      :class="{
                        'unactive-cube':
                          currentProcess() && currentProcess() !== 'printed',
                      }"
                    >
                      <b>
                        <h2 v-if="realizationMontage?.printed">Wydrukowany</h2>
                        <h2 v-else>Drukowanie</h2>
                        <small
                          v-if="
                            currentProcess() && currentProcess() === 'printed'
                          "
                        >
                          Aktualny etap
                        </small>
                        <small v-else>Następny etap</small>
                      </b>
                    </div>
                  </div>

                  <div class="col-md-3 border-left">
                    <div class="btn-group-vertical">
                      <button
                        @click="startProcess(realizationMontage.pk)"
                        :disabled="
                          !canChangeCurrentStatus() ||
                          !realizationMontage?.pk ||
                          realizationMontage?.realization_started ||
                          realizationMontage?.printed
                        "
                        class="btn btn-primary"
                      >
                        <span class="fa fa-play"></span>
                        <span> Rozpoczęcie pracy</span>
                      </button>
                      <button
                        @click="endProcess(realizationMontage?.pk, true)"
                        class="btn btn-primary"
                        :disabled="
                          !canChangeCurrentStatus() ||
                          !realizationMontage?.realization_started ||
                          realizationMontage?.printed
                        "
                      >
                        <span class="fa fa-stop"></span>
                        <span> Zakończenie pracy</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mActions = false" class="btn btn-white">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions" @click="mActions = false" class="modal-backdrop"></div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteMontage(showModal)"
    @callbackClose="showModal = false"
  />
  <Modal
    v-if="duplicateConfirmPk"
    :title="'Potwierdzenie działania'"
    :content="duplicateConfirmContent"
    @callbackOk="duplicateMontage"
    @callbackClose="duplicateConfirmPk = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { getPermittedSiteIds, hasPermission } from "../../permissions";
import { montagePermissionsConst } from "../../constants/productionConstants";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import Modal from "../caffeprint/Modal.vue";
import HistoryPopover from "../common/HistoryPopover.vue";
import { useMontageDuplicate } from "./useMontageDuplicate";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";

export default {
  name: "MontagesList",
  mixins: [],
  components: {
    Multiselect,
    Modal,
    HistoryPopover,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddMontage = computed(() =>
      hasPermission(montagePermissionsConst.add)
    );
    // The old panel's datatable shows the edit link only with the change
    // permission, even though the edit route itself needs just the view one.
    const canChangeMontage = computed(() =>
      hasPermission(montagePermissionsConst.update)
    );
    const canDeleteMontage = computed(() =>
      hasPermission(montagePermissionsConst.delete)
    );
    // The domain filter only makes sense when the user may view montages on
    // more than one site.
    const permittedSiteIds = getPermittedSiteIds(montagePermissionsConst.view);
    const canDisplaySites = computed(() => permittedSiteIds.length > 1);
    const sitesData = computed(() => store.getters.getSitesData);
    const montagesTableRef = ref(null);
    const montagesData = computed(() => store.getters.getMontagesData);
    const montageData = computed(() => store.getters.getMontageData);
    const montageProcessData = computed(
      () => store.getters.getMontageProcessData
    );
    const deleteMontageData = computed(
      () => store.getters.getDeleteMontageData
    );
    const montagesListSummary = computed(
      () => store.getters.getMontagesListSummary
    );
    const montagesListSummaryClosed = computed(
      () => store.getters.getMontagesListSummaryClosed
    );

    const paperList = computed(() => {
      return montagesListSummaryClosed.value?.data?.paper_format_list || [];
    });
    let headers = [
      { text: "Nr montażu", value: "pk", sortable: true, search: true },
      { text: "Nazwa", value: "name", sortable: true, search: true },
      {
        text: "Nakład netto",
        value: "quantity_net",
        sortable: true,
        search: true,
      },
      {
        text: "Nakład brutto",
        value: "quantity_brutto",
        sortable: true,
        search: true,
      },
      { text: "Papier", value: "paper_option", search: true },
      {
        text: "Format arkusza",
        value: "sheet_format",
        search: true,
      },
      { text: "Ilość płyt", value: "plate_quantity", search: true },
      { text: "Rodzaj płyt", value: "plate", search: true },
      { text: "Wartość zleceń netto", value: "products_net_value" },
      { text: "Koszt montażu", value: "montage_cost" },
      { text: "Koszt naddatku", value: "surplus_cost" },
      { text: "Różnica", value: "difference" },
      { text: "Procent", value: "percent" },
      { text: "Wartość dodatkowa netto", value: "extra_net" },
      { text: "Termin", value: "realization_date", sortable: true },
      { text: "Drukarz", value: "printer" },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    const filterOptions = ref([
      { name: "Tak", value: "True" },
      { name: "Nie", value: "False" },
    ]);

    const filterRWOptions = ref([
      { name: "Oczekuje na wystawienie RW", value: "awaiting" },
      { name: "RW wystawione automatycznie", value: "auto_issued" },
      { name: "RW wystawione ręcznie", value: "manual_issued" },
      { name: "RW niewystawione automatycznie", value: "auto_not_issued" },
    ]);

    const activeTab = ref("montages");
    const loading = ref(true);
    const mActions = ref(false);
    const prodProcess = ref();
    const searchValue = ref({});
    const summary = ref([]);
    const isSearch = ref(false);
    const showModal = ref(false);
    const deleteName = ref("");
    const rowsPerPage = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    const filters = ref({
      closed: [],
      mounted: [],
      printed: [],
      radiated: [],
      rw_status: [],
    });
    let items = ref([]);
    let itemsAll = ref(0);
    const sitePk = ref();
    const filterSites = ref([]);
    const siteFilterInitialized = ref(false);
    const realizationMontage = ref({});
    const lastProcess = ref({
      type: "",
      val: "",
    });
    const filterRangeDate = ref();
    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);

    const chevronFiltersClass = computed(() => {
      return isFiltersOpen.value ? "fa-chevron-up" : "fa-chevron-down";
    });

    const chevronMainClass = computed(() => {
      return isMainOpen.value ? "fa-chevron-up" : "fa-chevron-down";
    });

    const getMontageCard = (pk) => {
      store.dispatch("getMontageCard", { pk: pk });
    };

    const getMontages = async () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      // ensure site filter is applied via search params
      // build search payload without mutating reactive state
      const searchPayload = sitePk.value
        ? { ...searchValue.value, site_pk: sitePk.value }
        : { ...searchValue.value };
      await store.dispatch("getMontages", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchPayload,
        filters: filters.value,
        isArchive: "False",
        date: filterRangeDate.value,
      });
    };

    const getMontagesSummary = () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }

      // Przygotuj parametry filtrujące (bez paginacji)
      const summaryParams = {
        ordering: sort,
        search: sitePk.value
          ? { ...searchValue.value, site_pk: sitePk.value }
          : { ...searchValue.value },
        filters: filters.value,
        date: filterRangeDate.value,
        is_archive: "False",
      };
      store.dispatch("getMontagesListSummary", summaryParams);
      store.dispatch("getMontagesListSummaryClosed", summaryParams);
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getMontages();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = false;
      serverOptions.value.sortBy = "";
      filters.value = {
        closed: [],
        mounted: [],
        printed: [],
        radiated: [],
        rw_status: [],
      };
      getMontages();
      getMontagesSummary();
    };

    const updateSort = () => {
      isSearch.value = false;
    };

    const realization = (pk) => {
      if (!pk) {
        return;
      }

      realizationMontage.value.pk = pk;
      store.dispatch("getMontage", { pk: pk });
    };

    const startProcess = (pk) => {
      if (!canChangeCurrentStatus()) {
        return;
      }
      if (!pk) {
        if (realizationMontage.value?.pk) {
          pk = realizationMontage.value.pk;
        } else {
          console.error("No pk available from realizationMontage either");
          return;
        }
      }

      let payload = {
        pk: pk,
        type: "/start_process/",
      };

      store.dispatch("startMontageProcess", payload);
    };

    const endProcess = (pk, val, process) => {
      if (!canSetStatus(process || currentProcess())) {
        return;
      }
      let payload = {
        pk: pk,
        type: "/admin_state_update/",
      };

      if (!process) {
        const currentProc = currentProcess();
        payload[currentProc] = val;
        lastProcess.value.type = currentProc;
        lastProcess.value.val = val;
      } else {
        payload[process] = val;
        lastProcess.value.type = process;
        lastProcess.value.val = val;
      }

      store.dispatch("startMontageProcess", payload);
    };

    const showProcessBox = (process) => {
      if (!realizationMontage.value) return false;

      if (process === "closed") {
        if (realizationMontage.value?.mounted) {
          return false;
        } else {
          return true;
        }
      } else if (process === "mounted") {
        if (
          realizationMontage.value?.radiated &&
          realizationMontage.value?.printed
        ) {
          return false;
        } else {
          return true;
        }
      } else if (process === "radiated") {
        if (
          !realizationMontage.value?.closed &&
          !realizationMontage.value?.mounted
        ) {
          return false;
        } else {
          return true;
        }
      } else if (process === "printed") {
        if (
          !realizationMontage.value?.radiated &&
          !realizationMontage.value?.mounted
        ) {
          return false;
        } else {
          return true;
        }
      }
    };

    // Each realization status has a permission of its own; starting and
    // finishing work needs the permission of the current stage - the same
    // rules as MontageRealizationController in the old panel.
    const montageStatusPermissions = {
      closed: montagePermissionsConst.set_closed_montage_permission,
      mounted: montagePermissionsConst.set_mounted_montage_permission,
      radiated: montagePermissionsConst.set_radiated_montage_permission,
      printed: montagePermissionsConst.set_printed_montage_permission,
    };
    const canSetStatus = (status) =>
      Boolean(montageStatusPermissions[status]) &&
      hasPermission(montageStatusPermissions[status]);
    const canChangeCurrentStatus = () => {
      // A printed montage has no further stage to work on.
      if (realizationMontage.value?.printed) {
        return false;
      }
      return canSetStatus(currentProcess());
    };

    const currentProcess = () => {
      if (!realizationMontage.value) return null;

      let process;
      if (realizationMontage.value?.mounted) {
        if (realizationMontage.value?.radiated) {
          process = "printed";
        } else if (!realizationMontage.value?.printed) {
          process = "radiated";
        }
      } else if (!realizationMontage.value?.closed) {
        process = "closed";
      } else {
        process = "mounted";
      }

      return process;
    };

    const tableSummary = () => {
      let tempSummary = {
        quantity_net: 0,
        quantity_brutto: 0,
        products_net_value: 0,
        montage_cost: 0,
        surplus_cost: 0,
        difference: 0,
        percent: 0,
        plate_quantity: 0,
        extra_net: 0,
      };
      summary.value = [];
      items.value?.forEach((element) => {
        if (element?.isSummary) return;
        const montageCostWithExtra = getMontageCostWithExtra(element);
        tempSummary.quantity_net += element.quantity_net;
        tempSummary.quantity_brutto +=
          element.quantity_net + element.surplus_cost;
        tempSummary.products_net_value += element.products_net_value;
        tempSummary.montage_cost += montageCostWithExtra;
        tempSummary.surplus_cost += element.surplus_cost;
        tempSummary.difference += element.difference;
        tempSummary.plate_quantity += element.plate_quantity;
        tempSummary.extra_net += Number(element.extra_net) || 0;
      });
      const baseNet = Number(tempSummary.products_net_value) || 0;
      const totalCosts = Number(tempSummary.montage_cost) || 0;
      tempSummary.percent =
        baseNet !== 0 ? ((baseNet - totalCosts) / baseNet) * 100 : 0;
      summary.value.push(tempSummary);
    };

    const getMontageCostWithExtra = (item) =>
      (Number(item?.montage_cost) || 0) + (Number(item?.extra_net) || 0);

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const formatCurrency = (value) => {
      if (value === null || value === undefined) return "-";
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
      }).format(value);
    };

    const formatInt = (value) => {
      if (value === null || value === undefined || value === "") return "-";
      const number = Number(value);
      if (Number.isNaN(number)) return value;
      return new Intl.NumberFormat("pl-PL").format(Math.round(number));
    };

    const bodyRowClassNameFunction = (row) => {
      if (row && row.isSummary) {
        return "summary-row";
      }
      return false;
    };

    const getMaxPages = () => {
      const total = Number(itemsAll.value) || 0;
      const perPage = Number(serverOptions.value.rowsPerPage) || 1;
      return Math.max(1, Math.ceil(total / perPage));
    };

    const clampPage = (page) => {
      const max = getMaxPages();
      if (!page || Number.isNaN(Number(page))) return 1;
      return Math.min(Math.max(1, Number(page)), max);
    };

    const selectPage = (page) => {
      serverOptions.value.page = clampPage(page);
    };

    const setRowsPerPage = () => {
      const parsed = parseInt(rowsPerPage.value, 10);
      if (isNaN(parsed) || parsed <= 0) {
        rowsPerPage.value = serverOptions.value.rowsPerPage;
        return;
      }
      const clamped = Math.min(parsed, 1000);
      serverOptions.value.rowsPerPage = clamped;
      serverOptions.value.page = 1;
      rowsPerPage.value = clamped;
      isSearch.value = false;
    };

    const {
      canDuplicateMontage,
      duplicateConfirmPk,
      duplicateConfirmContent,
      isDuplicating,
      askDuplicateMontage,
      duplicateMontage,
    } = useMontageDuplicate();

    const deleteMontage = (pk) => {
      showModal.value = false;
      if (!canDeleteMontage.value) {
        return;
      }
      store.dispatch("deleteMontage", {
        pk: pk,
      });
    };

    onMounted(() => {
      if (localStorage.getItem("montagesRowsPerPage") !== null) {
        const saved = parseInt(localStorage.getItem("montagesRowsPerPage"), 10);
        if (!isNaN(saved) && saved > 0) {
          serverOptions.value.rowsPerPage = saved;
        }
      }
      rowsPerPage.value = serverOptions.value.rowsPerPage;
      if (localStorage.getItem("montagesSearchValue") !== null) {
        if (localStorage.getItem("montagesSearchValue") !== "{}") {
          searchValue.value = localStorage.getItem("montagesSearchValue");
          searchValue.value = JSON.parse(searchValue.value);
        }
      }
      if (localStorage.getItem("montagesFilters") !== null) {
        filters.value = localStorage.getItem("montagesFilters");
        filters.value = JSON.parse(filters.value);
      }
      if (
        localStorage.getItem("montagesRangeDate") !== null &&
        localStorage.getItem("montagesRangeDate") !== undefined
      ) {
        filterRangeDate.value = localStorage.getItem("montagesRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }
      if (localStorage.getItem("montagesSitePk") !== null) {
        const savedSite = parseInt(localStorage.getItem("montagesSitePk"), 10);
        if (!isNaN(savedSite)) sitePk.value = savedSite;
      }
      store.dispatch("getSites");
      const tableRoot = montagesTableRef.value?.$el;
      if (tableRoot) {
        tableRoot.addEventListener(
          "contextmenu",
          (e) => {
            e.stopPropagation();
          },
          true
        );
      }
    });

    watch(
      () => [filters.value],
      function () {
        localStorage.setItem("montagesFilters", JSON.stringify(filters.value));
        getMontages();
        getMontagesSummary();
      },
      { deep: true }
    );

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "montagesSearchValue",
          JSON.stringify(searchValue.value)
        );
        if (filterRangeDate.value !== undefined) {
          localStorage.setItem(
            "montagesRangeDate",
            JSON.stringify(filterRangeDate.value)
          );
        }
        getMontages();
        getMontagesSummary();
      },
      { deep: true }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        if (newValue?.data?.results) {
          filterSites.value = newValue.data.results
            .filter((el) => permittedSiteIds.includes(el.pk))
            .map((el) => ({
              name: el.name,
              value: el.pk,
            }));

          if (!hasSiteOptionValue(filterSites.value, sitePk.value)) {
            const defaultSiteValue = getSiteValueFromCurrentUrl(
              filterSites.value
            );
            if (defaultSiteValue !== null) {
              sitePk.value = defaultSiteValue;
            }
          }

          if (!siteFilterInitialized.value) {
            siteFilterInitialized.value = true;
            getMontages();
            getMontagesSummary();
          }
        }
      }
    );

    watch(
      () => sitePk.value,
      function (newVal) {
        if (newVal) {
          localStorage.setItem("montagesSitePk", String(newVal));
        } else {
          localStorage.removeItem("montagesSitePk");
        }
        getMontages();
        getMontagesSummary();
      }
    );

    watch(
      () => montagesData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        tableSummary();
        if (summary.value[0]) {
          const s = summary.value[0];
          const toNum = (v) =>
            v && v.toFixed ? Number(v.toFixed(2)) : Number(v);
          items.value.push({
            isSummary: true,
            quantity_net: toNum(s.quantity_net),
            quantity_brutto: toNum(s.quantity_brutto),
            products_net_value: toNum(s.products_net_value),
            montage_cost: toNum(s.montage_cost),
            surplus_cost: toNum(s.surplus_cost),
            difference: toNum(s.difference),
            percent: toNum(s.percent),
            extra_net: toNum(s.extra_net),
            plate_quantity: s.plate_quantity,
          });
        }
        loading.value = false;
      }
    );

    watch(
      () => montageData.value,
      function (newValue) {
        if (newValue && newValue.data) {
          const existingPk = realizationMontage.value?.pk;
          realizationMontage.value = { ...newValue.data };
          if (existingPk && !realizationMontage.value.pk) {
            realizationMontage.value.pk = existingPk;
          }
          if (realizationMontage.value?.pk) {
            mActions.value = true;
          } else {
            console.error("No pk in montage data, not showing modal");
            mActions.value = false;
          }
        } else if (newValue && newValue.response && newValue.response.data) {
          const existingPk = realizationMontage.value?.pk;
          realizationMontage.value = { ...newValue.response.data };
          if (existingPk && !realizationMontage.value.pk) {
            realizationMontage.value.pk = existingPk;
          }

          if (realizationMontage.value?.pk) {
            mActions.value = true;
          } else {
            console.error("No pk in montage response data, not showing modal");
            mActions.value = false;
          }
        } else {
          if (!realizationMontage.value?.pk) {
            mActions.value = false;
          }
        }
      }
    );

    watch(
      () => montageProcessData.value,
      function (newValue) {
        if (newValue.data === "started") {
          if (realizationMontage.value?.pk) {
            store.dispatch("getMontage", { pk: realizationMontage.value.pk });
          }
        } else {
          if (newValue.status === 200) {
            getMontages();
            let responseText;
            if (lastProcess.value.type === "closed") {
              if (lastProcess.value.val) {
                responseText = "Montaż został zamknięty!";
              } else {
                responseText = "Montaż został otwarty!";
              }
            }
            if (lastProcess.value.type === "mounted") {
              if (lastProcess.value.val) {
                responseText = "Montaż został zmontowany!";
              } else {
                responseText = "Montowanie montażu zostało cofnięte!";
              }
            }
            if (lastProcess.value.type === "radiated") {
              if (lastProcess.value.val) {
                responseText = "Montaż został naświetlony!";
              } else {
                responseText = "Naświetlenie montażu zostało cofnięte!";
              }
            }
            if (lastProcess.value.type === "printed") {
              if (lastProcess.value.val) {
                responseText = "Montaż został wydrukowany!";
              } else {
                responseText = "Wydrukowanie montażu zostało cofnięte!";
              }
            }
            mActions.value = false;
            store.dispatch("showToaster", {
              type: "success",
              content: responseText,
            });
          } else {
            var msg = [];
            for (const [key, value] of Object.entries(newValue.data)) {
              msg.push(key + ": " + value);
            }
            store.dispatch("showToaster", {
              type: "error",
              content: msg[0],
            });
          }
        }
      }
    );

    watch(
      () => deleteMontageData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Montaż został usunięty",
          });
        }
        getMontages();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        localStorage.setItem(
          "montagesRowsPerPage",
          String(serverOptions.value.rowsPerPage)
        );
        if (!isSearch.value) {
          getMontages();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      canAddMontage,
      canChangeMontage,
      canDeleteMontage,
      canDuplicateMontage,
      duplicateConfirmPk,
      duplicateConfirmContent,
      isDuplicating,
      askDuplicateMontage,
      duplicateMontage,
      canDisplaySites,
      canSetStatus,
      canChangeCurrentStatus,
      activeTab,
      montagesTableRef,
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      mActions,
      prodProcess,
      searchValue,
      summary,
      isSearch,
      showModal,
      deleteName,
      rowsPerPage,
      filters,
      filterOptions,
      filterRWOptions,
      sitesData,
      realizationMontage,
      getMontageCard,
      clampPage,
      getMaxPages,
      getMontages,
      search,
      resetFilters,
      updateSort,
      realization,
      startProcess,
      endProcess,
      showProcessBox,
      currentProcess,
      tableSummary,
      getMontageCostWithExtra,
      format,
      formatCurrency,
      formatInt,
      selectPage,
      setRowsPerPage,
      onMounted,
      deleteMontage,
      bodyRowClassNameFunction,
      filterRangeDate,
      montagesListSummary,
      montagesListSummaryClosed,
      paperList,
      getMontagesSummary,
      isFiltersOpen,
      chevronFiltersClass,
      isMainOpen,
      chevronMainClass,
      sitePk,
      filterSites,
    };
  },
  computed: {},
};
</script>

<style scoped>
.context-menu {
  position: fixed;
  z-index: 2147483647;
  background: #ffffff;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  padding: 6px 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  display: grid;
  grid-auto-flow: row;
  gap: 6px;
}

.summary-tiles {
  margin-top: 15px;
  margin-bottom: 10px;
}

.summary-tile {
  position: relative;
  background: #ffffff;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.summary-tile-label {
  font-size: 12px;
  color: #6b6e70;
}

.summary-tile-value {
  font-size: 20px;
  font-weight: 600;
  color: #1ab394;
}

/* Move the value away from the right edge for popover tile */
.has-popover .summary-tile-value {
  margin-right: 15px;
}

.has-popover .summary-popover {
  display: none;
  position: absolute;
  z-index: 2147483647;
  top: calc(100% + 2px);
  left: 0;
  margin-top: 0;
  width: max(100%, 260px);
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);
  padding: 8px 10px;
}

.has-popover:hover .summary-popover {
  display: block;
}

/* Keep visible when moving cursor from tile to popover */
.has-popover .summary-popover:hover {
  display: block;
}

.summary-popover-title {
  font-weight: 600;
  font-size: 12px;
  color: #6b6e70;
  margin-bottom: 6px;
}

.summary-popover-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 220px;
  overflow: auto;
}

.summary-popover-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #dee2e6;
  font-weight: 600;
  font-size: 11px;
  color: #6b6e70;
  text-transform: uppercase;
}

.summary-popover-list li {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 8px;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed #eef1f3;
}

.summary-popover-list li:last-child {
  border-bottom: none;
}

.paper-name {
  font-size: 12px;
  color: #333;
}

.paper-format {
  font-size: 12px;
  color: #666;
  text-align: center;
}

.paper-total {
  font-weight: 600;
  color: #1ab394;
  text-align: center;
}

.table-summary {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.summary-labels,
.summary-values {
  margin: 0;
  font-size: 14px;
}

.summary-labels .col-md-1,
.summary-labels .col-md-2,
.summary-values .col-md-1,
.summary-values .col-md-2 {
  padding: 8px;
  text-align: center;
  border-right: 1px solid #dee2e6;
}

.summary-labels .col-md-1:last-child,
.summary-labels .col-md-2:last-child,
.summary-values .col-md-1:last-child,
.summary-values .col-md-2:last-child {
  border-right: none;
}

.summary-labels strong {
  color: #495057;
  font-size: 12px;
}

.summary-values strong {
  color: #495057;
}

.summary-values .text-muted {
  color: #6c757d;
  font-size: 12px;
}

.summary-labels {
  border-bottom: 1px solid #dee2e6;
  background-color: #e9ecef;
}

/* Style dla nowych zakładek */
.custom-tabs {
  margin-bottom: 20px;
}

.tab-buttons {
  display: flex;
  gap: 10px;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0;
}

.tab-button {
  background: none;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.tab-button:hover {
  background-color: #f8f9fa;
  color: #495057;
}

.tab-button.active {
  background-color: #1ab394;
  color: white;
  box-shadow: 0 2px 8px rgba(26, 179, 148, 0.3);
}

.tab-button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #1ab394;
}

.tab-button i {
  font-size: 16px;
}

.tab-button span {
  font-weight: 500;
}

.tab-content {
  padding: 20px 0;
}

/* Usuń marginesy dla zakładki produktów */
.tab-content:has(.ibox) {
  padding: 0;
}

/* Style dla zakładki produktów - klasy no-margins */
div[v-if="activeTab === 'products'"] .ibox.no-margins {
  margin: 0 !important;
  padding: 0 !important;
}

div[v-if="activeTab === 'products'"] .ibox-title.no-margins {
  margin: 0 !important;
  padding: 10px 15px 5px 15px !important;
}

div[v-if="activeTab === 'products'"] .ibox-content.no-margins {
  margin: 0 !important;
  padding: 10px 15px 15px 15px !important;
}

div[v-if="activeTab === 'products'"] .row:first-child {
  margin-top: 0 !important;
}

div[v-if="activeTab === 'products'"] .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

/* Wiersz podsumowania jak w dodawaniu montaży */
.summary-row {
  background-color: #f8f9fa !important;
  font-weight: bold;
  border-top: 2px solid #dee2e6;
}

.summary-row td {
  background-color: #f8f9fa !important;
  font-weight: bold;
}
</style>
